/**
 * Show slide thumbnails.
 *
 * @param {object} Splide Current Splide instance reference.
 * @param {object} Components Current Splide components.
 * @returns {object} Splide component.
 */
function SlideThumbnails( Splide, Components ) {
	const { root } = Components.Elements;

	const thumbnails = [];
	let current;

	const mount = () => {
		const images = root.querySelectorAll( '.kaplan-carousel__list img' );
		if ( ! images?.length ) {
			return;
		}

		const list = document.createElement( 'ol' );
		list.className = 'kaplan-carousel__thumbnails';

		const { Slides } = Splide.Components;

		images.forEach( ( image, index ) => {
			let button = document.createElement( 'button' );
			button.type = 'button';
			button.setAttribute( 'aria-label', `Go to slide ${index + 1}` );
			button.setAttribute( 'aria-controls', Slides.get()[ index ].slide.id );
			button.appendChild( image.cloneNode() );

			button.addEventListener( 'click', event => {
				Splide.go( index );
			} );

			thumbnails[ index ] = button;

			const li = document.createElement( 'li' );
			li.appendChild( button );

			list.appendChild( li );
		} );

		root.parentElement.insertBefore( list, root.nextSibling );

		if ( thumbnails.length > 3 ) {
			setTimeout( () => list.scrollBy( { left: 32 } ), 0 );
		}

		update();

		Splide.on( 'mounted move', update );
		Splide.on( 'destroy', remove );
	};

	const update = () => {
		const thumbnail = thumbnails[ Splide.index ];

		if ( ! thumbnail ) {
			return;
		}

		if ( current ) {
			current.removeAttribute( 'aria-current' );
		}

		thumbnail.setAttribute( 'aria-current', 'true' );
		current = thumbnail;

		/**
		 * thumbnail.scrollIntoView() would be better, but it causes vertical page scroll too.
		 */
		const list = thumbnail.closest( '.kaplan-carousel__thumbnails' );
		const offsetRight = thumbnail.offsetLeft + thumbnail.clientWidth;
		if ( offsetRight >  list.scrollLeft + list.clientWidth ) {
			list.scrollTo( { left: ( offsetRight - list.clientWidth ) } );
		} else if ( list.scrollLeft > thumbnail.offsetLeft ) {
			list.scrollTo( { left: thumbnail.offsetLeft } );
		}
	};

	const remove = () => {
		// Clear all thumbnails;
		thumbnails.length = 0;

		root.parentElement.querySelector( '.kaplan-carousel__thumbnails' )?.remove();

		current = undefined;
	};

	return {
		mount,
	};
}

export default SlideThumbnails;
